import { Spinner } from '@change/ds-core-ui';

import { withPrefetchedData } from '#src/shared/prefetch';

import { prefetchPageContext, TopicSitemapPageContextProvider } from '#src/app/pages/topic/sitemap/pageContext';
import type { TopicSitemapPagePrefetchedDataProps } from '#src/app/pages/topic/sitemap/pageContext';

import { Layout } from '../layout';

import { TopicSitemapErrorHandler } from './ErrorHandler';

export const TopicSitemap = withPrefetchedData(
	function TopicSitemap({ prefetchedData }: TopicSitemapPagePrefetchedDataProps) {
		return (
			<TopicSitemapPageContextProvider
				prefetchedData={prefetchedData}
				errorHandler={TopicSitemapErrorHandler}
				loadingFallback={<Spinner className="mx-auto my-64" />}
			>
				<Layout />
			</TopicSitemapPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,

		prefetchData: async (context) => prefetchPageContext(context),
		// FIXME: i18n
		pageTitle: ({ fromTemplate }) => fromTemplate('Browse by Topic'),
		pageMetadata: () => ({
			// FIXME: i18n
			description:
				'Discover petitions on the issues you care about. Support causes that matter and drive change on Change.org.',
			ogTitle: 'Browse by Topic',
			ogType: 'website' as const,
			twitterImageAlt: 'Browse by Topic',
		}),
	},
);
